import "../assets/styles/about.scss"
import BlogPosts from "../components/BlogPosts";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { ReactComponent as ArrowIcon } from '../assets/images/linkArrow.svg';
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import React, { useRef, useEffect  } from 'react';

function AboutUs() {
    const navigate = useNavigate();

    useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top on mount

    }, []);
  return (
       <div className="about-us-container">
        <Header/>
    <div className="main-container">

       <div className="about-banner">
        <h1>گروه حمل و نقل وطن</h1>
        <p>
      پیشینه <span>گروه حمل‌ونقل وطن</span>  به سال ۱۳۴۸ خورشیدی بازمی‌گردد. زمانی که مرحوم حاج محمود پیراسته در قلبِ پایتخت، یعنی در محدوده بازار تهران و خیابان شوش، اقدام به راه‌اندازی موسسه باربری وطن نمود و کمی بعد، نام تجاری <span>باربری وطن</span> به نام‌آشناترین مجموعه باربری در شهر تهران تبدیل شد. امروزه گروه حمل‌ونقل وطن شامل: حمل‌ونقل وطن (با نام تجاری وطن)، شرکت اقتصاد (فعال در حوزه حمل‌ونقل)، موسسه حمل‌ونقل سعادت اصفهان و انبارهای نگهداری کالای امانی منتظران می‌باشد.
        </p>

        <p style={{marginTop:16}}>
حمل‌ونقل وطن با دارا بودنِ ۳۰ هزار متر مربع ترمین مرکزی و ۱۲ هزار متر مربع سالن‌های مهجز به سیستم اطفا حریق و دوربین‌های مداربسته با ارسال روزانهٔ کالای مشتریان توسط ۲۵۰ دستگاه تریلی و دیگر خودروهای باری سبک و سنگین (به‌طور میانگین) به بیش از ۳۰۰ شعبه و نمایندگی در سراسر کشور، طیف وسیعی از مشتریان از جمله بازارها، شرکت‌ها، کارخانجات صنعتی، بنگاه‌ها، مشتریان خانگی و ... را پوشش می‌دهد. این مجموعه بزرگ و چابک به پشتوانه بیش از ۵۰ سال اعتماد مشتریان خود و ۳۵۰۰ نفر کادر پویا و کارآزموده،  به یکی از بزرگ‌ترین سامانه‌های حمل بار در ایران تبدیل شده است و اکنون در تلاش است تا با به‌روز کردنِ خدمات و سرویس‌های خود، راهکارهایی نوین در حوزه حمل‌ونقل باری در ایران ارائه دهد.
        </p>
       </div>

       <div className="about-content-container">
        <div className="content-texts">
          <span>وطن در یک نگاه</span>
          <h1>ما از قدیمی‌ترین و بزرگ‌ترین مجموعه‌های حمل‌ونقل در ایران هستیم.</h1>
          <p>باربری وطن به واسطه بیش از ۵۰ سال سابقه در حوزه حمل‌ونقل خرده بار بین‌شهری و دارا بودن امکانات وسیع لجستیکی و محیطی، شبکه بزرگ حمل‌ونقلی خود را ایجاد کرده است.</p>
        </div>
       <div className="about-widgets">
        <div className="first-column">
          <img src={require('../assets/images/about1.png')} alt="about1"/>
          <div className="widget-text">
            <span className="title">3 هکتار مساحت ترمینال مرکزی</span>
            <p>
              <span style={{fontSize:'1.875rem'}}>۳۰ هزار متر مربع </span>  فضای بارانداز در ترمینال مرکزی.
            </p>
          </div>
          <img src={require('../assets/images/about2.png')} alt="about2"/>
        </div>
        <div className="second-column">
          <div className="widget-text">
          <span className="title">دریافت ۲۴ ساعته بار در ترمینال مرکزی</span>
          <p>
          <span style={{fontSize:'1.875rem'}}>۲۴ ساعت</span> شبانه‌روز آماده دریافت بار از مشتریان.
          </p>
          </div>
          <img src={require('../assets/images/about3.png')} alt="about3"/>

          <div className="widget-text">
          <span className="title">انبارهای تخلیه و بارگیری کالا</span>
          <p>
          <span style={{fontSize:'1.875rem'}}>۱۲ هزار متر مربع</span> سالن‌های مجهز به سیستم توزین، اطفا حریق و دوربین‌های مداربسته.
          </p>
          </div>
        </div>
        <div className="third-column">
        <img src={require('../assets/images/about4.png')} alt="about4"/>
          <div className="widget-text">
          <span className="title">شبکه توزیع کالا در تمام استان‌ها</span>
          <p>
          <span style={{fontSize:'1.875rem'}}>۳۰۰ نمایندگی</span> در سراسر کشور جهت تحویل بار.
          </p>
          </div>

          <img src={require('../assets/images/about5.png')} alt="about5"/> 
        </div>
        <div className="forth-column">

        <div className="widget-text">
          <span className="title">تاسیس در سال ۱۳۴۸</span>
          <p>
          <span style={{fontSize:'1.875rem'}}>۵۰ سال</span> قدمت و تجربه در حوزه حمل‌و‌نقل.
          </p>
          </div>

          <img src={require('../assets/images/about6.png')} alt="about6"/>

          <div className="widget-text">
          <span className="title">ناوگان ارسال کالا به سراسر کشور</span>
          <p>
          <span style={{fontSize:'1.875rem'}}>۲۵۰ دستگاه</span> تریلی و دیگر خودروهای باری سبک و سنگین به صورت روزانه جهت ارسال بار.
          </p>
          </div>

        </div>
       </div>

       
       <div className="link-cards-container">
              <a href='/vipClient' target='_blank' className="link-card first-link-card">
                  <h3>خدمات وطن برای مشتریان ویژه تجاری</h3>
                  <span>ارسال بار شرکت‌ها، موسسات و مراکز تجاری، بازرگانی، صنعتی، خدماتی و فروشگاه‌های آنلاین با شرایط ویژه زمانی، نرخی و بیمه‌ای.</span>
      
                  <img src={require('../assets/images/homeTools.png')} alt=""/>
      
                  <button><ArrowIcon className="arrow-icon"/></button>
              </a>
      
              <a href='/express' target='_blank' className="link-card vip">
                  <h3>ارسال کالا با وطن اکسپرس</h3>
                  <span>تحویل آنی بار شما در مقصد نهایی، بدون نیاز به عملیات پذیرش و معطلی با بسته‌بندی ویژه و حمل توسط خودروی مخصوص.</span>
      
                  <img src={require('../assets/images/truckSquare.png')}/>
      
                  <button><ArrowIcon className="arrow-icon-vip"/></button>
              </a>
            </div>

       <div className="blog-posts-container">
         <BlogPosts />

       </div>

       <Footer bgColor={'#fff'}/>

       </div>
    </div>

    </div>
  );
}

export default AboutUs;
